<template lang="pug">
v-chip(
  v-bind="$data.$_attrs"
  :outlined="outlined"
  :text-color="textColor"
  :color="color"
  v-on="$data.$_listeners"
  :class="classes"
  @input="$emit('close')"
  tabindex="-1"
).font-weight-bold.ma-0
  .small-caps--small
    slot
  k-icon(
    v-if="removable"
    :color="textColor"
    @click="$emit('close')"
    size="10"
  ).cursor-pointer.k-chip__close--btn.pl-2 times
</template>

<script>
import { BindsAttrs } from '@/mixins'

export default {
  mixins: [ BindsAttrs ],
  inheritAttrs: false,
  props: {
    removable: {
      type: Boolean,
      default: false
    },
    textColor: {
      type: String,
      default: 'accent',
    },
    color: {
      type: String,
      default: 'var(--v-light-aqua-base)',
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    xSmall: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    classes () {
      return {
        'k-chip': true,
        'k-chip--removable': this.removable,
        'k-chip--outlined': this.outlined,
        'k-chip--small': this.small,
        'k-chip--x-small': this.xSmall,
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.k-chip {
  // disable highlights
  &::before {
    display: none !important;
  }

  ::v-deep {
    .v-ripple__container {
      display: none !important;
    }
  }

  padding: 0 15px !important;

  &--outlined {
    border: 2px solid !important;
    color: inherit;
  }

  &--small {
    padding: 0 9px !important;
  }

  &--x-small {
    border-radius: 67px !important;
    height: 20px !important;
    padding: 0 12px !important;

    ::v-deep .v-chip {
      height: 20px !important;
    }
  }

  &__close--btn {
    height: 50%;
    margin: 0 !important;
  }

  .v-btn::before {
    opacity: 0 !important;
  }
}
</style>
